import type { DefaultToastOptions } from 'react-hot-toast';
import { palette } from './palette';

/**
 * Global toast options.
 *
 * Errors auto-dismiss after a generous-but-finite window. They used to be
 * `duration: Infinity`, but react-hot-toast toasts have no built-in dismiss
 * affordance, so an error (e.g. "Passwords do not match" on registration) would
 * stick on screen forever with no way to close it. A finite duration lets the
 * user fix the field and have the toast clear itself.
 *
 * Styling (2026-07-01 design refresh): the brand glass chrome — frosted white,
 * palette border, layered deep-teal pop shadow — so toasts speak the same
 * visual language as modals and chart tooltips. Values mirror the tailwind
 * elevation tokens (`shadow-pop`), which CSS-in-JS options can't reference
 * directly; keep them in sync via tailwind.config.js if the tokens move.
 */
export const TOAST_OPTIONS: DefaultToastOptions = {
  duration: 4000,
  style: {
    background: 'rgba(255, 255, 255, 0.92)',
    backdropFilter: 'blur(10px) saturate(1.4)',
    WebkitBackdropFilter: 'blur(10px) saturate(1.4)',
    border: `1px solid ${palette.border}`,
    borderRadius: 12,
    boxShadow: '0 24px 64px -16px rgba(5, 27, 24, 0.35)',
    color: palette.ink,
    fontSize: '13.5px',
    fontWeight: 500,
    padding: '10px 14px',
  },
  success: { iconTheme: { primary: palette.success, secondary: palette.successLight } },
  error: {
    duration: 6000,
    iconTheme: { primary: palette.danger, secondary: palette.dangerLight },
  },
};
